 
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { ElementFormatType, FORMAT_ELEMENT_COMMAND } from "lexical";

export const useFormatElement = () => {
  const [editor] = useLexicalComposerContext();

  return (elementFormatType: ElementFormatType) => editor.dispatchCommand(FORMAT_ELEMENT_COMMAND, elementFormatType);
};
